import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14 3H7C5.895 3 5 3.895 5 5V19C5 20.105 5.895 21 7 21H17C18.105 21 19 20.105 19 19V8H15C14.448 8 14 7.552 14 7V3Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 3H14.172C14.702 3 15.211 3.211 15.586 3.586L18.414 6.414C18.789 6.789 19 7.298 19 7.828V19M7 3C5.895 3 5 3.895 5 5V19C5 20.105 5.895 21 7 21H17C18.105 21 19 20.105 19 19M7 3H14V7C14 7.552 14.448 8 15 8H19V19",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgDocumentFilled);
export default ForwardRef;
